import { timeline } from 'wix-animations';
import { memory } from 'wix-storage';
import { openLightbox, formFactor } from 'wix-window';
import { getUserDetails } from '../public/wixUsers';

import * as CONSTS from '../public/consts.js';

export function makeResponsive(elementId, textTheme, fontSize, fontColor, lineHeight, charSpacing, width, textAlign) {
    let style = "font-size:" + fontSize + "vw;color:" + fontColor + ";line-height:" + lineHeight + ";letter-spacing:" + charSpacing + "vw;width:" + width + "vw" + ";text-align:" + textAlign;
    $w(elementId).html = "<" + textTheme + " style=" + style + ">" + $w(elementId).text + "</" + textTheme + ">"
}

export function linkTextInner($element, link, target = '_self') {
    const { html } = $element
    const text = html.match(/<.*>(.*[^>])<\/.*>/)[1]
    const linkedText = `<a href="${link}" target="${target}" style="display:block;">${text}</a>`
    const linkedHtml = html.replace(text, linkedText)
    $element.html = linkedHtml
}

export function linkText(text, link, target = '_self') {
    const textHtml = text.html;

    if (textHtml.indexOf('href=') > -1) {
        text.html = textHtml.replace(
            textHtml.substring(textHtml.lastIndexOf("href=") + 5).split(' ')[0],
            link
        );
        return;
    }
    text.html = `<a href="${link}" target="${target}" style="display:block;">${textHtml}</a>`;
}

export function runOpacityHoverEffect(element, opacity) {
    let timeLine = timeline();
    timeLine.add(element, {
            "opacity": opacity,
            "duration": 150,
            "easing": "easeInOutCubic"
        })
        .play();
}

let changeTextColorPause = false
export function changeTextColor(element, color, sec = false) {
	if (changeTextColorPause) return
	changeTextColorPause = true
	setTimeout(() => changeTextColorPause = false, 100)
    
    let textHtml = element.html;
    const hoverColor = CONSTS.colors.blue;
    const index = textHtml.lastIndexOf('style="')
    const colorIndex = textHtml.substring(index).indexOf('color');
    let newHtml;
    switch (true) {
    case colorIndex < 0:
        newHtml = textHtml.slice(0, index + 7) + `color:${color};` + textHtml.slice(index + 7);
        break;
    case color !== hoverColor:
        newHtml = textHtml.replace(/color:#166AEA;/g, `color:${color};`);
        break;
    default:
        if (sec) {
            newHtml = textHtml.replace(/color:#ffffff;/g, `color:${color};`);
            break;
        }
        newHtml = textHtml.replace(/color:#000000;/g, `color:${color};`);
        break;

    }
    element.html = newHtml;
}

let underlineTextPause = false
export function underlineText(text, style) {
	if (underlineTextPause) return
	underlineTextPause = true
	setTimeout(() => underlineTextPause = false, 100)

    let textHtml = text.html;
    const index = textHtml.lastIndexOf('style="')
    const colorIndex = textHtml.substring(index).indexOf('text-decoration');
    let newHtml;
    if (colorIndex < 0 && style) {
        newHtml = textHtml.slice(0, index + 7) + `text-decoration-line:underline;` + textHtml.slice(index + 7);
    } else {
        if (style) {
            newHtml = textHtml.replace(/text-decoration-line:none;/g, `text-decoration-line:underline;`);
        } else {
            newHtml = textHtml.replace(/text-decoration-line:underline;/g, `text-decoration-line:none;`);
        }
    }
    text.html = newHtml;
}

export function resetCustomSectionStyle(postsData, postsImages, currentIndex, style) {
    for (let i = 0; i < postsImages.length; i++) {
        if (i === currentIndex) {
            switch (style) {
            case 'color':
                underlineText(postsData[i], false);
                runOpacityHoverEffect(postsImages[i], 1);
                break;
            case 'underline':
                runOpacityHoverEffect(postsImages[i], 1);
                break;
            case 'opacity':
                underlineText(postsData[i], false);
                break;
            }
        } else {
            underlineText(postsData[i], false)
        }
    }
}

export function resetStyles(currentElement, styleType) {
    const posts = ['post1', 'post2', 'post3', 'post4', 'post5', 'post6', 'mainPost', 'secPost'];
    const index = posts.indexOf(currentElement);
    if (index > -1) {
        posts.splice(index, 1);
    }
    const isPostSec = currentElement === 'secPost' ? true : false;
    const color = isPostSec ? CONSTS.colors.white : CONSTS.colors.black;

    switch (styleType) {
    case 'color':
        underlineText($w(`#${currentElement}Title`), false);
        runOpacityHoverEffect($w(`#${currentElement}Column`), 1);
        break;
    case 'underline':
        runOpacityHoverEffect($w(`#${currentElement}Column`), 1);
        changeTextColor($w(`#${currentElement}Category`), color, isPostSec);
        break;
    case 'opacity':
        changeTextColor($w(`#${currentElement}Category`), color, isPostSec);
        underlineText($w(`#${currentElement}Title`), false)
        break;
    default:
        break;
    }
    posts.forEach(post => {
        const isPostSec = post === 'secPost' ? true : false;
        const color = isPostSec ? CONSTS.colors.white : CONSTS.colors.black;
        changeTextColor($w(`#${post}Category`), color, isPostSec);
        underlineText($w(`#${post}Title`), false);
        runOpacityHoverEffect($w(`#${post}Column`), 1);
    })
}

export function showBanner() {
    // CHECK IF IT'S A USER
    getUserDetails()
        .then(user => {
            //it's a user
            let savedUserEmail = user.email;
        })
        .catch((err) => {
            //it's not a user - show banner
            let boolUserSawBannner = memory.getItem("userSawBanner");
            setTimeout(function () {
                if (boolUserSawBannner === null) {
                    memory.setItem("userSawBanner", "true");
                    if (formFactor !== "Mobile") {
                        openLightbox("Banner");
                    }
                }
            }, 3000);
        });

}